/** Slice B — subscription through formMessages */
import { organizationOwnerSubject, workspaceNounTitle } from "@Front/Utils/publicSiteBranding";

const workspaceLower = workspaceNounTitle().toLowerCase();

export const COMMON_UI_I18N_PART1_SLICE_B = {
	subscription: {
		discoverOffersCta: "Découvrir nos offres",
		backToPlatformCta: "Retour à la plateforme",
		planNameLabel: "Nom du plan",
		planNameRequiredSuffix: "*",
		planNamePlaceholder: "Ex: Plan Standard - 5 licences",
		planDescriptionLabel: "Description (optionnelle)",
		planDescriptionPlaceholder: "Ex: Plan professionnel avec 5 licences incluses",
		planTypeLabel: "Type",
		planTypeTitle: "Type de plan",
		planSeatsPlaceholder: "Ex: 5 (-1 pour illimité)",
		planSeatsHint: "Entrez -1 pour un nombre illimité de licences",
		seatsLabel: "Nombre de licences",
		seatsRequiredSuffix: "*",
		planDurationLabel: "Durée (en mois)",
		planDurationPlaceholder: "Ex: 1, 6, 12",
		planDurationHint: "Entre 1 et 120 mois",
		planPriceLabel: "Prix (en centimes)",
		planPricePlaceholder: "Ex: 2900 pour 29,00 €",
		planPriceHintPrefix: "Minimum 100 centimes (1,00 €). Aperçu:",
		planDefaultLabel: "Définir comme plan par défaut",
		planDefaultHint: "Si coché, ce plan sera proposé par défaut lors des nouvelles souscriptions",
		unlimitedCollaboratorsTitle: "Nombre de collaborateurs illimité",
	},
	health: {
		anchor: {
			title: "Ancrage Bitcoin réel",
			dataLabel: "Données à ancrer (optionnel)",
			hashLabel: "Hash (optionnel)",
			loadingText: "Test en cours...",
			submitCta: "Tester l'ancrage",
		},
		ipfs: {
			title: "Pinata — vérification des accès",
			filePrefixLabel: "Préfixe du fichier (optionnel)",
			fileContentLabel: "Contenu du fichier (optionnel, non envoyé à Pinata)",
			loadingText: "Vérification...",
			submitCta: "Vérifier les identifiants Pinata",
			readOnlyCredentialSuccess:
				"Identifiants Pinata reconnus (lecture seule). Les nouveaux fichiers sont enregistrés chiffrés sur le serveur ; Pinata sert aux documents déjà stockés sur IPFS.",
			legacyIpfsTestGatewayIntro:
				"Référence IPFS renvoyée par l’API (comportement historique avec dépôt de test) — lien passerelle :",
		},
		mail: {
			title: "Mailchimp (live)",
			recipientLabel: "Destinataire",
			subjectLabel: "Sujet",
			contentLabel: "Contenu",
			loadingText: "Envoi...",
			submitCta: "Envoyer un e-mail",
		},
		sms: {
			title: "SMS OVH (live)",
			numberLabel: "Numéro",
			messageLabel: "Message",
			loadingText: "Envoi...",
			submitCta: "Envoyer un SMS",
		},
		idNotUser: {
			title: "ID.NOT Auth - Profil utilisateur",
			idLabel: "Identifiant ID.NOT utilisateur",
			loadingText: "Requête...",
			submitCta: "Récupérer le profil",
		},
		idNotOffice: {
			title: "ID.NOT Directory - Office",
			idLabel: "Identifiant ID.NOT office",
			loadingText: "Requête...",
			submitCta: "Récupérer l'office",
		},
	},
	healthMessages: {
		anchorDescription: "Genere un hash (ou utilise le votre) et le soumet a l'API Signet. Le lien mempool est affiche.",
		ipfsDescription:
			"Vérifie que les clés Pinata répondent (sans déposer de fichier). Les nouveaux fichiers sont toujours enregistrés chiffrés sur le serveur ; la passerelle sert à lire l’historique IPFS.",
		mailDescription: "Declenche l'envoi d'un e-mail via Mailchimp Transactional.",
		smsDescription: 'Envoi reel du SMS de test. Le statut doit afficher "Message envoye".',
		idNotUserDescription: "Appel direct de l'API IdNot Auth pour recuperer les rattachements utilisateur.",
		idNotOfficeDescription: "Recupere les details d'un office via l'annuaire IdNot.",
	},
	subscriptionMessages: {
		cancelSubscriptionIntro: "Avant de confirmer, veuillez prendre note des conséquences suivantes :",
		cancelSubscriptionConsequence1:
			"Arrêt des fonctionnalités : Vous n'aurez plus accès aux outils de traitement et de mise à jour en temps réel.",
		cancelSubscriptionConsequence2:
			"Accès limité : Vous pourrez uniquement télécharger vos documents existants, sans possibilité de les éditer ou de créer de nouveaux fichiers.",
		subscriptionEndNotice:
			"Votre abonnement se terminera le XX/XX/XXXX. Assurez-vous de sauvegarder tout ce dont vous avez besoin avant cette date.",
		removeSeatsNotice:
			'En cas de suppression de sièges, les derniers comptes ajoutés seront concernés. Vous pouvez réattribuer les sièges sur la page "Gérer mes attributions".',
		infoLineOnboarding:
			"Accompagnement facilité : profitez d'un onboarding individualisé, où nous vous guidons pour une prise en main optimale de l'application",
		infoLineSupport: "Support technique : notre équipe support est disponible pour vous assister en cas d'incident",
		infoLineUpdates:
			"Mises à jour régulières : bénéficiez de mises à jour fréquentes pour profiter des dernières fonctionnalités, améliorations de sécurité et performances optimisées",
		infoLineUnlimitedUsers: "Sans limite d'utilisateurs",
		stripeAccessDeniedWarning: "Vous n'avez pas les droits pour gérer la facturation Stripe.",
		stripeManualBillingInfoTitle: "Facturation manuelle",
	},
	subscriptionAdminMessages: {
		createPlanSuccess: "Plan créé avec succès.",
		createPlanError: "Erreur lors de la création du plan",
		toggleStatusError: "Erreur lors de la modification du statut",
		setDefaultConfirmTitle: "Définir ce plan comme plan par défaut ?",
		setDefaultConfirmMessage: "Le plan sélectionné deviendra le plan de référence pour les nouvelles souscriptions.",
		setDefaultSuccess: "Plan par défaut mis à jour avec succès.",
		setDefaultError: "Erreur lors de la modification du plan par défaut",
		deleteConfirmTitlePrefix: "Supprimer le plan",
		deleteConfirmTitleSuffix: "?",
		deleteConfirmMessage: "Cette action désactivera le plan (soft delete).",
		deleteSuccess: "Plan supprimé avec succès.",
		deleteError: "Erreur lors de la suppression",
	},
	userMessages: {
		selectUserHint: "Sélectionnez un utilisateur",
		modalUserFallback: "cet utilisateur",
		superAdminNominateVerb: "Nommer",
		superAdminRevokeVerb: "Retirer",
		superAdminVoteTitlePrefix: "Souhaitez-vous attribuer un vote à",
		superAdminVoteTitleTargetAdd: "devenir",
		superAdminVoteTitleTargetRemove: "retirer son rôle de",
		superAdminVoteTitleSuffix: "Super Administrateur ?",
		adminRoleTitleAddPrefix: "Souhaitez-vous nommer",
		adminRoleTitleAddSuffix: `administrateur de son ${workspaceLower} ?`,
		adminRoleTitleRemovePrefix: `Souhaitez-vous retirer le rôle administrateur de son ${workspaceLower} à`,
		adminRoleTitleRemoveSuffix: "?",
		superAdminVoteNominate:
			"Un ou des collaborateurs souhaitent attribuer le titre de Super Admin à ce collaborateur.",
		superAdminVoteRevoke:
			"Un ou des collaborateurs souhaitent retirer le titre de Super Admin à ce collaborateur.",
		superAdminVoteMissingPrefix: "Il manque",
		superAdminVoteMissingSuffixNominate: "vote(s) pour que le collaborateur se voit attribuer le titre.",
		superAdminVoteMissingSuffixRevoke: "vote(s) pour que le collaborateur se voit retirer le titre.",
		superAdminVoteModalBody:
			"une personne Super Administrateur nécessite 3 votes de super administrateurs existants. Souhaitez-vous attribuer un vote ?",
	},
	usersMessages: {
		informationsTitle: "Informations des utilisateurs",
		userFallbackName: "Utilisateur",
		officeFallbackName: `${workspaceNounTitle()} non défini`,
		lastNameLabel: "Nom",
		firstNameLabel: "Prénom",
		phoneLabel: "Numéro de téléphone",
		emailLabel: "Email",
		roleInOfficeTitle: `Rôle au sein de son ${workspaceLower}`,
		assignTitleLabel: "Attribuer un titre",
		adminOfficeSwitchLabel: `Admin de son ${workspaceLower}`,
		superAdminSwitchRolePrefix: "Super-admin ",
		superAdminGrantedToastPrefix: "Le titre de super-administrateur a été attribué à",
		superAdminRevokedToastPrefix: "Le titre de super-administrateur a été retiré à",
	},
	documentMessages: {
		validatePrompt: "Êtes-vous sûr de vouloir valider ce document ?",
		refusePrompt: "Veuillez indiquer au client le motif du refus de son document afin qu'il puisse vous renvoyer une bonne version.",
		refuseReasonPlaceholder: "Motif du refus",
		noAccess: "Vous n'avez pas les droits nécessaires pour consulter ce document.",
		noFile: "Ce document n'a pas de fichier disponible",
		validateOrRefuseHint: "Veuillez valider ou refuser ce document.",
		depositorPendingWithoutDate: `Ce document est en attente de validation par ${organizationOwnerSubject()}.`,
		unsupportedFormat: "L'affichage de ce format de fichier n'est pas supporté.",
		downloadHint: "Vous pouvez télécharger le fichier pour le consulter.",
		validationActionsHint: "Vous pouvez valider ou refuser ce document en utilisant les boutons en bas de page.",
		hiddenContentNotice: "Le contenu du document n'est pas affiché. Consultez le message ci-dessous.",
		sendDocumentsLoadingFolder: "Chargement du dossier…",
		sendDocumentsTitle: "Envoyer des documents, sélectionnez les destinataires :",
		sendDocumentsMergeNote:
			"Les fichiers ajoutés seront fusionnés en un seul PDF. Pour envoyer plusieurs documents séparés, effectuez plusieurs envois.",
		sendDocumentsRecipientsQuestion:
			"Voulez-vous envoyer ce document à tous les membres du dossier (clients et tiers) ou sélectionner certains destinataires ?",
		sendDocumentsAllRecipients: "Sélectionner tous les membres du dossier",
		sendDocumentsSelectedRecipients: "Sélectionner certains destinataires",
		sendDocumentsRecipientsLabel: "Choisir les destinataires (clients et/ou tiers) : ",
		sendDocumentsAcceptedFormats:
			"Formats acceptés : PDF, JPG, JPEG, PNG, GIF, WebP, CSV, TXT, DOC, DOCX, PPT, PPTX, ODT, ODP Taille maximale : 100 Mo",
		downloadDocumentsError: "Erreur lors du téléchargement des documents",
		aggregatedCertificateMixedTypesError: "Impossible de générer un certificat agrégé pour un mélange de types de documents.",
		aggregatedCertificateMaxDocumentsError: "Le nombre maximum de documents par certificat agrégé est de 100.",
		aggregatedCertificateGenericError:
			"Erreur lors de la génération du certificat. Veuillez réessayer ou contacter le support si le problème persiste.",
		aggregatedCertificateDownloadError: "Erreur lors du téléchargement du certificat agrégé",
		downloadStarted: "Téléchargement lancé.",
		aggregatedCertificateDownloadStarted: "Téléchargement du certificat lancé.",
		anchorCertificateDownloadError: "Erreur lors du téléchargement du certificat",
		documentCreateFailed: "Le document n'a pas pu être créé.",
		documentLoadFailed: "Impossible de charger ce document.",
		documentNotFound: "Document introuvable.",
		documentInvalid: "Ce document n'est pas valide.",
		multipleActiveFilesDownloadTitle: "Plusieurs fichiers actifs sur ce document",
		multipleActiveFilesDownloadDescription:
			"Le téléchargement utilise la version la plus récente. Si ce message apparaît souvent, signalez-le au support : les pièces devraient être regroupées en un seul PDF.",
		noFileAvailable: "Aucun fichier disponible au téléchargement.",
		downloadImpossible: "Téléchargement impossible.",
		noDocumentAvailable: "Aucun document disponible au téléchargement.",
		removeInvitedNotaryFailed: "Impossible de retirer le notaire invité du dossier.",
		removeThirdPartyFailed: "Impossible de retirer le tiers du dossier.",
		deleteRibTitle: "Supprimer le RIB",
		deleteRibMessage: `Voulez-vous vraiment supprimer le RIB de votre ${workspaceLower} ?`,
		deleteDeedTypeTitle: "Supprimer le type d'acte ?",
		deleteDeedTypeMessage: "Êtes-vous sûr de vouloir supprimer ce type d'acte ?",
	},
	formMessages: {
		thirdPartySearchPlaceholder: "Rechercher par nom, prénom, email ou société...",
		thirdPartyPhonePlaceholder: "Téléphone (facultatif)",
		thirdPartyDescriptionPlaceholder: "Description (facultatif)",
		confrereSearchPlaceholder: "Nom, email ou office du notaire",
		confrereOfficeSearchPlaceholder: "Nom de l'office ou du notaire",
		confrerePreferredEmailPlaceholder: "notaire@etude.notaires.fr",
	},
} as const;
